const NAMESPACE = {
  OPM_API: 'opmApi',
  INTL_API: 'intlApi',
  NEW_INTL_API: 'newIntlApi',
  QCINTL_WOA_API: 'qcintlWoaApi',
  QCINTL_WOA_API_DEV: 'qcintlWoaApiDev',
  ACCOUNT_API: 'accountApi',
  TRANS_API: 'transApi',
  OFFICIAL_API: 'officialApi',
  QCINTL_API: 'qcintlApi',
  CMS_API: 'cmsApi',
  CMS_PREVIEW_API: 'cmsPreviewApi',
  BUY_API: 'buyApi',
  CHANNEL_API: 'channelApi',
};

/**
 * 配置的key值，调用get方法的时候使用
 * @type {Object<string, string>}
 */
const CONFIG_KEYS = {
  opm: 'opm',
  commonConfig: 'commonConfig',
  apiConfig: 'apiConfig',
  secretConfig: 'secretConfig',
};

/**
 * 北极星环境变量配置，获取服务时传入
 */

const ENV = process.env.NODE_ENV;

const ENV_POLARIS = {
  development: 'Development',
  test: 'Test',
  preview: 'Pre-release',
  production: 'Production',
};

export { CONFIG_KEYS, ENV, ENV_POLARIS, NAMESPACE };
